import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/highRiskIndustries');

export default function FISPersonHint() {
  return <Content />;
}
